<template>
  <div class="body con-wd">
    <breadcrumb :data="['项目', '创建项目', '任务中心', '文档编辑']"></breadcrumb>
    <div class="container">
      <el-row>
        <el-col :span="6">
          <div class="left">
            <el-menu :default-active="currentModuleId" :default-openeds="defOpens">
              <menu-tree v-loading="moduleLoading" @menuclick="onMenuClick" :data="modules"></menu-tree>
            </el-menu>
          </div>
          <div class="but">
            <el-button @click="addProjectDesc">添加项目介绍</el-button>
            <br />
            <!--            <el-button @click="addCustomPage" style="margin-top: 12px">添加自定义页</el-button>-->
          </div>
        </el-col>
        <CustomPage
          ref="customPage"
          :fileType="fileType"
          v-on:confirm="onAddCustomConfirm"
          :taskId="documentId"
        ></CustomPage>
        <el-col :span="18">
          <div class="right">
            <el-row>
              <el-col :span="10" class="texttop">文档页面</el-col>
              <el-col :span="12" :style="{ textAlign: 'right' }">
                <el-input
                  type="text"
                  size="small"
                  suffix-icon="el-icon-search"
                  v-model="sourceFilter.keyWord"
                  placeholder="请输入"
                  style="width: 270px; cursor: pointer"
                  @keyup.enter.native="handleSearch"
                ></el-input>
              </el-col>
              <el-col v-if="showUpDir" :span="2" style="padding-left: 20px">
                <el-upload action="#" :on-change="onUploadChange" :show-file-list="false" :auto-upload="false">
                  <el-button slot="default">上传目录</el-button>
                </el-upload>
              </el-col>
            </el-row>
            <div class="tag-con" v-if="selectTags.length > 0">
              <div class="label">已选标签：</div>
              <div class="selects">
                <span
                  title="点击可删除"
                  @click="onSelectTagClick(tag)"
                  v-for="(tag, index) in selectTags"
                  :key="tag + '-' + index"
                >
                  {{ tag }}
                </span>
              </div>
            </div>
            <div class="tag-con">
              <div class="label">推荐标签：</div>
              <div class="tags" :class="['tags', { open: tagsOpen }]">
                <span
                  :class="{ active: selectTags.indexOf(val) > -1 }"
                  v-for="(val, index) in taglist"
                  :key="index"
                  @click="handleSelectTag(val)"
                >
                  {{ val }}
                </span>
              </div>
              <div class="option">
                <span @click="tagsOpen = !tagsOpen">
                  <template v-if="!tagsOpen">
                    <i class="el-icon-arrow-down"></i>
                  </template>
                  <template v-else>
                    <i class="el-icon-arrow-up"></i>
                  </template>
                </span>
              </div>
            </div>
            <el-scrollbar v-loading="loading" class="scrollbar-con">
              <div class="tagimg" v-if="!loading">
                <div class="item" v-for="(item, index) in filterTagList" :key="'tagimg-' + index">
                  <div
                    class="imga"
                    @mouseenter="mouseEntrImage(item)"
                    @mouseleave="mouseLeaveImage(item)"
                    :title="item.fileName"
                  >
                    <el-image
                      :ref="'el-image-' + index"
                      :style="fileType === 0 ? { width: '180px', height: '93px' } : { width: '180px' }"
                      :src="item.imageUrl"
                      :preview-src-list="[item.imageUrl]"
                      lazy
                    ></el-image>
                    <div v-show="item.showMark" class="mark">
                      <div class="handle-wrap" style="width: 100%">
                        <!--                          <el-button @click="$refs['el-image-' + index][0].clickHandler()">-->
                        <!--                            查看大图-->
                        <!--                          </el-button>-->
                        <el-button @click="goPreview(item.lxPreviewUrl)">查看预览</el-button>
                      </div>
                    </div>
                    <div
                      @click="handleItemSelect(item)"
                      :class="[item.isRequired ? 'mselected' : item.selected ? 'selected' : 'normal']"
                    ></div>
                  </div>
                </div>
              </div>
            </el-scrollbar>

            <el-row
              :style="{
                marginTop: '20px',
                borderTop: '1px solid rgba(0, 0, 0, 0.06)',
                padding: '21px 0',
              }"
            >
              <el-col :span="12">
                <el-checkbox v-model="isSelectAll" @change="handleSelectAll">全选</el-checkbox>
                <span style="margin-left: 10px">|</span>
                <span style="margin-left: 10px">已选择{{ selectAllCount }}条</span>
              </el-col>
              <el-col :style="{ textAlign: 'right' }" :span="12">
                <el-button @click="addToMoveableList" type="primary" plain>添加至编辑栏</el-button>
              </el-col>
            </el-row>
            <div></div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="drawer-con">
      <div class="btn-con">
        <div v-if="drawerVisible" @click="onDrawerClick" class="close"></div>
        <div v-else @click="onDrawerClick" class="open"></div>
      </div>

      <div class="list-con" v-show="drawerVisible">
        <div class="title">
          预览
          <span class="clear" @click="clearDoc">清空</span>
        </div>
        <div class="img-con" v-loading="dirLoading">
          <move-list
            ref="moveList"
            @updateList="setFodderCheckStatus"
            :fileType="fileType"
            :list="moveableList"
          ></move-list>
        </div>
        <div :style="{ textAlign: 'center', padding: '16px 0' }">
          <el-button @click="save" type="primary" plain>保存</el-button>
          <el-button @click="next" type="primary">下一步</el-button>
        </div>
      </div>
      <div v-show="!drawerVisible" style="width: 10px; height: 10px"></div>
    </div>
  </div>
</template>

<script>
import CustomPage from "@/components/pc/CustomPage";
import Breadcrumb from "@/components/pc/Breadcrumb";
import MenuTree from "@/components/pc/Menutree";
import { getMixImage } from "@/utils/tools.js";
import { mapMutations } from "vuex";
import MoveList from "@/components/pc/MoveList";
import {testSave} from "../../api/projectManage";
const cacheName = "cacheDir";
const cacheMoveList = "moveList";
export default {
  name: "editDocument",
  components: {
    Breadcrumb,
    // Draggable,
    MoveList,
    MenuTree,
    CustomPage,
  },
  beforeCreate() {
    document.body.setAttribute("style", "background:#F4F4F5;");
  },
  beforeDestroy() {
    document.body.setAttribute("style", "background:#ffffff;");
  },
  data() {
    return {
      fromPath: "",
      fileType: null,
      loading: false,
      documentId: undefined,
      businessOpprtunityId: undefined,
      defaultProps: {
        children: "children",
        label: "label",
      },
      tagsOpen: false,
      defOpens: [],
      drawerVisible: false,
      taglist: [],
      selectTags: [],
      fodderList: [],
      modules: [],
      moduleLoading: false,
      imageWrapLoading: false,
      sourceFilter: {
        keyWord: "",
        taskId: 0,
        fileName: "", //关键字
        moduleId: "",
        tagName: "", //标签名用 ”,“分割
        type: 0, //0 所有的  1启用的 前台传1
        startDateTime: "", //开始时间 时间戳
        endDateTime: "", //结束时间  时间戳
      },
      total: 0,
      dirLoading: false,
      moveableList: [],
      selectAll: false,
      hasDefaultSelected: false,
      currentModule: null,
      customPageModule: null,
      projectIntrosModule: null,
      cacheName: "",
      cacheMoveListName: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(from);
      //  这里的vm指的就是vue实例，可以用来当做this使用
      vm.fromPath = from.path; //获取上一级路由的路径
    });
  },
  created() {
    this.documentId = this.$route.params.id;
    this.businessOpprtunityId = this.$route.params.did;
    this.getSaveList(this.documentId)
  },
  mounted() {
    this.documentId = this.$route.params.id;
    this.businessOpprtunityId = this.$route.params.did;

    this.changeMenuStatus({ value: 1 });
    // //0 是新创建的 右侧不要显示侧边栏
    this.hasDefaultSelected = JSON.parse(this.$route.query.hasDefaultSelected);
    this.getSelectedModules();
    this.cacheName = cacheName + this.businessOpprtunityId + "/" + this.documentId;
    this.cacheMoveListName = cacheMoveList + this.businessOpprtunityId + "/" + this.documentId;
    //判断是否存在缓存
    console.log(this.moveableList, '测试')
    // let moveListCache = localStorage.getItem(this.cacheMoveListName);
    // if (moveListCache) {
    //   let moveListData = JSON.parse(moveListCache);
    //   console.log(moveListData, 122222)
    //   this.moveableList = moveListData;
    // }
  },
  computed: {
    selectedIds() {
      //判断是否存在缓存
      let moveListCache = localStorage.getItem(this.cacheMoveListName);
      const url = `/manage/addcover/${this.documentId}/${this.businessOpprtunityId}/${this.fileType}`;
      if (moveListCache && (this.fromPath === url || this.fromPath === "/")) {
        this.getSaveList(this.documentId)
        // let moveListData = JSON.parse(moveListCache);
        // // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        // this.moveableList = moveListData;
      } else {
        localStorage.removeItem(this.cacheMoveListName);
      }
      let result = [];
      this.moveableList.forEach(item => {
        if (item.links.length > 0) {
          item.links.forEach(link => {
            if (!result.includes(link.id)) {
              result.push(link.id);
            }
          });
        }
      });
      return result;
    },
    currentModuleId() {
      return this.currentModule?.moduleId;
    },
    isSelectAll() {
      return this.filterTagList.length ? this.filterTagList.every(item => item.selected) : false;
    },
    selectAllCount() {
      let count = 0;
      let selectObjs = this.fodderList.filter(item => item.selected);
      count = selectObjs.length;
      return count;
    },
    filterTagList() {
      let result = this.fodderList.filter(item => {
        let hasKeyword = item.fileName.indexOf(this.sourceFilter.keyWord) > -1;
        let filterTags = item.tagList.filter(tag => {
          return this.selectTags.indexOf(tag.tagsName) > -1;
        });
        return hasKeyword && filterTags.length === this.selectTags.length;
      });
      return result;
    },
    showUpDir() {
      return this.fileType == 1 && this.moveableList.every(item => item.links.length == 0);
    },
  },
  methods: {
    // 查询保存的素材
    getSaveList(taskId) {
      var moveableList = [
        {
          id: null,
          name: "",
          selected: true,
          links: [],
        },
      ];
      testSave(taskId).then(res => {
        if(res.data.length > 0) {
          res.data.forEach(item => {
            if (item.links === null) {
              item.links = []
            }
          });
          this.moveableList = res.data;
        }else {
          this.moveableList = moveableList
        }
      })
    },
    addEnum() {
      // if(this.fileType===0){
      let moveableList = [
        {
          id: null,
          name: "",
          selected: true,
          links: [],
        },
      ];
      this.moveableList = moveableList;
      // }
    },
    ...mapMutations(["changeMenuStatus"]),
    onUploadChange(file) {
      if (file.size > 0) {
        let data = new FormData();
        data.append("file1", file.raw);
        this.dirLoading = true;
        this.drawerVisible = true;
        this.$request
          .uploadDirectoryWord(data, this.documentId)
          .then(res => {
            console.log(res, "res");
            if (res.code == 200) {
              let moveableList = res.data.catalogList?.map(item => {
                return {
                  id: item.id,
                  name: item.name,
                  selected: false,
                  links: item.links,
                };
              });
              this.moveableList = moveableList;
            }
            this.dirLoading = false;
          })
          .finally(_ => {
            this.dirLoading = false;
          });
      }
    },
    clearDoc() {
      this.moveableList = [];
      this.addEnum();
      this.filterTagList.forEach(item => {
        item.selected = false;
      });
      localStorage.removeItem(this.cacheMoveListName);
      localStorage.removeItem(this.cacheName);
    },
    onDrawerClick() {
      this.drawerVisible = !this.drawerVisible;
    },
    /**
     * 获取任务的模块
     */
    mouseEntrImage(item) {
      if (
        this.fileType === 1 &&
        this.currentModule !== this.projectIntrosModule &&
        this.currentModule !== this.customPageModule
      ) {
        item.showMark = true;
      }
    },
    mouseLeaveImage(item) {
      if (
        this.fileType === 1 &&
        this.currentModule !== this.projectIntrosModule &&
        this.currentModule !== this.customPageModule
      ) {
        item.showMark = false;
      }
    },
    goPreview(url) {
      window.open(url);
    },
    getSelectedModules() {
      this.moduleLoading = true;
      this.$request
        .getSelectedModules(this.documentId)
        .then(res => {
          if (res.code === 200) {
            const moduleList = res.data.data;
            this.initLinks(moduleList);
            this.fileType = res.data.type;
            this.addEnum();
            this.getSaveList(this.documentId)
            this.modules = moduleList;
            this.defOpens = this.getAllModuleIds(moduleList);
            this.currentModule = this.getDefaultActiveModule(moduleList);
            // if (this.moduleType === 0) {
            const data = this.modules[0].children;
            this.projectIntrosModule = this.currentModule;
            const lastModule = data[data.length - 1];
            if (lastModule.moduleName === "自定义页") {
              this.customPageModule = lastModule;
            }
            this.getRequiredSource();
          }
        })
        .finally(_ => {
          this.moduleLoading = false;
        });
    },
    initLinks(list) {
      list.forEach(item => {
        if (item.children && item.children.length) {
          this.initLinks(item.children);
        } else {
          item.links = [];
        }
      });
    },
    /**
     * 添加项目介绍
     */
    addProjectDesc() {
      this.$refs.customPage.init(0);
    },
    /**
     * 添加自定义页
     */
    addCustomPage() {
      this.$refs.customPage.init(1);
    },
    /**
     * 处理搜索，记录搜索关键词
     */
    handleSearch() {
      this.$request.saveKeyword({ keyword: this.sourceFilter.keyWord });
    },
    async getRequiredSource() {
      try {
        this.loading = true;
        let data = null;
        let cachedTagsData = localStorage.getItem(this.cacheName);
        // let cachedTagsData = localStorage.getItem(this.cacheMoveListName);

        if (cachedTagsData) {
          //加入已经缓存的links
          data = JSON.parse(cachedTagsData).moduleSelectedMap;
        } else if (this.hasDefaultSelected) {
          //获取已保存或者复制的项目

          const res = await this.$request.getTaskInfo(this.documentId);
          // const result = await this.$request.getTaskSelectSourceList(this.documentId);
          // 设置勾选
          data = res.data;
          this.setMoveListLinks(data);
        }
      } catch (err) {
        console.log(err);
      } finally {
        if (!this.drawerVisible) {
          this.drawerVisible = true;
          this.loading = false;
        }
        this.$nextTick(() => {
          this.onMenuClick(this.currentModule);
        });
      }
    },
    setMoveListLinks(info) {
      let moveableList = [];

      // const allLinks = [];
      // for (const key in data) {
      //   if (Object.hasOwnProperty.call(data, key)) {
      //     const links = data[key];
      //     links.forEach(item => {
      //       allLinks.push(item);
      //     });
      //   }
      // }

      if (info.hasDirectory == 0) {
        const links = [];
        info.selectedFodderIds.forEach(item => {
          links.push(...item.links);
        });
        moveableList = [{ id: null, name: "", selected: true, links: links }];
      } else {
        console.log(123)
        // moveableList = info.selectedFodderIds.map((item, index) => {
        //   return {
        //     id: item.id,
        //     name: item.name,
        //     links: allLinks.filter(link => item.links.includes(link.id)),
        //     selected: index == 0 ? true : false,
        //   };
        // });
        moveableList = info.selectedFodderIds.map((item, index) => {
          return {
            id: item.id,
            name: item.name,
            links: item.links,
            selected: index == 0 ? true : false,
          };
        });
      }
      this.moveableList = moveableList;
      this.$forceUpdate();
    },
    /**
     * 获取 模块中的第一个 默认选中
     * @param modules
     * @returns {{children}|*}
     */
    getDefaultActiveModule(modules) {
      if (modules) {
        const module = modules[0];
        if (module && module.children && module.children.length) {
          return this.getDefaultActiveModule(module.children);
        } else {
          return module;
        }
      }
    },
    /**
     * 获取所有模块id
     * @param item
     * @param ids
     */
    getAllModuleIds(moduleList) {
      const ids = [];
      moduleList.forEach(item => {
        ids.push(item.moduleId);
        if (item.children && item.children.length) {
          ids.push(...this.getAllModuleIds(item.children));
        }
      });
      return ids;
    },
    onSelectTagClick(tag) {
      let index = this.selectTags.findIndex(item => item === tag);
      if (index > -1) {
        this.selectTags.splice(index, 1);
      }
    },
    /**
     * 处理 标签选择
     * @param tag
     */
    handleSelectTag(tag) {
      let index = this.selectTags.findIndex(item => item === tag);
      if (index > -1) {
        this.selectTags.splice(index, 1);
      } else {
        this.selectTags.push(tag);
      }
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 20);
    },
    /**
     *  全选
     * @param select
     */
    handleSelectAll(select) {
      this.filterTagList.forEach(item => {
        if (!item.isRequired) {
          item.selected = select;
        }
      });
    },

    /**
     *  添加自定义页 和 项目介绍回调
     * @param data
     * @param type
     * @returns {Promise<void>}
     */
    async onAddCustomConfirm(data, type) {
      try {
        // const fodder = await this.handleImage([data],type === 1 ? customPage : projectIntro)
        if (type === 1) {
          // 自定义模板
          if (this.currentModule === this.customPageModule) {
            this.fodderList.unshift(data);
          } else {
            // 是否存在 自定义页
            await this.onMenuClick(this.customPageModule);
          }
        } else if (type === 0) {
          if (this.currentModule === this.projectIntrosModule) {
            this.fodderList.unshift(data);
          } else {
            await this.onMenuClick(this.projectIntrosModule);
          }
        }
      } finally {
        this.loading = false;
      }
    },
    getSaveData() {
      let result = {
        taskId: this.documentId,
        selectedFodderIds: null,
      };

      let selectedFodderIds = this.moveableList.map(item => {
        let { id, name } = { ...item };
        let links = item.links.map(link => link.id);
        return { id, name, links };
      });
      result.selectedFodderIds = selectedFodderIds;
      return result;
    },
    /**
     * 后去需保存的数据 包含右侧移动的素材
     * @returns {{selectorLinkIds: *[], projectIntroIds: *[], customPageIds: *[], taskId}}
     */
    getSaveDataOld() {
      const data = {
        taskId: this.documentId,
        selectedFodderIds: [],
        selectedCount: 0,
        moduleSelectedMap: this.getMovEListLinks(),
      };
      let allLinks = this.getSelectFodder();
      if (allLinks && allLinks.length) {
        allLinks.forEach(item => {
          data.selectedFodderIds.push(item.id);
          if (this.fileType === 0) {
            data.selectedCount += 1;
          } else {
            if (item.perPage) {
              data.selectedCount += item.perPage;
            } else {
              data.selectedCount += 1;
            }
          }
        });
      }
      return data;
    },
    /**
     * 下一步
     */
    next() {
      if (!this.moveableList.some(item => item.links.length > 0)) {
        this.$message.warning("请选择素材");
        return;
      }
      let catchData = this.getSaveData();
      // if (!catchData.selectedFodderIds?.length) {
      //   this.$message.warning("请勾选素材后再点击下一步");
      //   return;
      // }
      localStorage.setItem(this.cacheName, JSON.stringify(catchData));
      localStorage.setItem(this.cacheMoveListName, JSON.stringify(this.moveableList));
      this.$router.push(`/manage/addcover/${this.documentId}/${this.businessOpprtunityId}/${this.fileType}`);
    },
    /**
     * 保存
     */
    save() {
      let data = this.getSaveData();
      localStorage.setItem(this.cacheName, JSON.stringify(data));
      this.$request.saveTask(data).then(res => {
        if (res.code === 200) {
          this.$message.success("保存成功");
        }
      });
    },
    /**
     * 添加到右侧移动列表
     */
    addToMoveableList() {
      if (this.moveableList.length == 0) {
        this.$message.warning("请先上传目录文档");
        return;
      }
      if (!this.moveableList.some(item => item.selected)) {
        this.$message.warning("请先选择要移至的目录");
        return;
      }
      // const currentModuleSeletedFodderIds = this.currentModule.links.map(item => item.id);
      let selectIds = this.selectedIds;
      let selectLinks = this.moveableList.find(item => item.selected).links;

      this.filterTagList.forEach(item => {
        if (item.selected && !selectLinks.some(obj => obj.id == item.id)) {
          if (!selectIds.includes(item.id)) {
            selectLinks.push(item);
          }
        }
      });
      if (!this.drawerVisible) {
        this.drawerVisible = true;
      }
    },
    checkDirectory() {
      return this.moveableList.length > 0;
    },
    /**
     * 处理图片点击选中
     * @param item
     */
    async handleItemSelect(item) {
      console.log(item, 123)
      if (item.isRequired) {
        return;
      }
      //查询是否过期

      if (!item.selected) {
        await this.$request.checkCertificateExpired(item.id).then(res => {
          if (res.code == 200) {
            if (!res.data) {
              this.$confirm(res.msg, "提示", {
                confirmButtonText: "我知道了",
                showCancelButton: false,
              });
            }
          }
        });
      }

      if (this.currentModule === this.projectIntrosModule) {
        let ids = this.fodderList.filter(item => item.selected).map(item => item.id);
        if (ids.length > 0 && !ids.includes(item.id)) {
          this.$message.warning("项目介绍只能勾选一个");
          return;
        }
      }
      item.selected = !item.selected;
      this.$forceUpdate();
    },
    /**
     * 处理模块点击
     * @param obj
     * @returns {Promise<void>}
     */
    async onMenuClick(obj) {
      this.currentModule = obj;
      this.sourceFilter.keyWord = "";
      this.selectTags = [];
      this.sourceFilter.moduleId = this.currentModule.moduleId;
      this.tagsOpen = false;
      this.getFodderList();
    },
    /**
     * 获取素材
     */
    getFodderList() {
      this.loading = true;
      this.sourceFilter.taskId = this.documentId;
      this.sourceFilter.tagName = this.selectTags.join(",");
      const moduleId = this.currentModule.moduleId;
      this.$request
        .getSourceList(this.sourceFilter)
        .then(res => {
          if (this.currentModule.moduleId === moduleId) {
            let dataList = res.data.data;
            if (res.data.tagList) {
              this.taglist = res.data.tagList.map(item => item.tagsName);
            } else {
              this.taglist = [];
            }
            this.setFodderCheckStatus(dataList);
            if (res.data.fileType === 1) {
              dataList.forEach(item => {
                item.showMark = false;
              });
            }

            this.fodderList = dataList;
          }
        })
        .finally(_ => {
          if (this.currentModule.moduleId === moduleId) {
            this.loading = false;
          }
        });
    },
    /**
     *  设置选中状态
     * @param dataList
     */
    setFodderCheckStatus(dataList) {
      // let allLinks = this.getSelectFodder();

      let allLinks = this.selectedIds;
      dataList?.forEach(item => {
        if (item.isRequired) {
          item.selected = true;
        } else {
          let selected = false;
          if (allLinks.length > 0) {
            let selObj = allLinks.find(link => link === item.id);
            if (selObj) {
              selected = true;
            }
          }
          item.selected = selected;
        }
      });
    },
  },
};
</script>
<style lang="less">
.el-submenu__title,
.el-menu-item {
  &:hover {
    background-color: transparent !important;
  }

  &:focus {
    background-color: transparent !important;
  }
}
</style>
<style lang="less" scoped>
.but {
  text-align: right;
  margin-right: 16px;
  margin-top: 20px;
}

.container {
  .left {
    padding-left: 0 !important;

    & .el-menu {
      border-right: 0 !important;
    }
  }

  .right {
    padding-right: 156px;

    .texttop {
      font-size: 16px;
      font-family: Inter-Medium, Inter;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
    }

    .tag-con {
      display: flex;
      padding-top: 16px;

      & > .label {
        margin-top: 4px;
        flex: 0 0 auto;
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
      }
      & > .selects {
        font-size: 12px;
        & > span {
          border: 1px solid #ccc;
          margin: 0 4px 8px 4px;
          display: inline-block;
          padding: 0 8px;
          height: 24px;
          line-height: 24px;
          cursor: pointer;
          border-radius: 2px;
        }
      }

      & > .tags {
        flex: 1;
        height: 26px;
        overflow: hidden;

        & > span {
          margin: 0 8px 8px 8px;
          display: inline-block;
          padding: 0 8px;
          background-color: #f5f5f5;
          border-radius: 2px;
          color: rgba(0, 0, 0, 0.85);
          height: 24px;
          line-height: 24px;
          cursor: pointer;
          font-size: 12px;

          &:hover {
            background: #e60027;
            color: #fff;
          }

          &.active {
            background: #e60027;
            color: #fff;
          }
        }

        &.open {
          height: auto;
          overflow: auto;
        }
      }

      & > .option {
        flex: 0 0 auto;
        padding: 5px;

        & > span {
          cursor: pointer;
        }
      }
    }

    .tagimg {
      display: flex;
      flex-wrap: wrap;
      min-height: 300px;
      justify-content: space-between;

      .item {
        flex: 0 0 180px;
        cursor: pointer;
        // margin: 0 18px 16px 18px;
        margin-bottom: 16px;

        .imga {
          //width: 180px;
          //height: 93px;
          box-sizing: border-box;
          border: 1px solid #eee;
          position: relative;
          & > .normal {
            border-radius: 2px;
            position: absolute;
            right: 6px;
            top: 6px;
            width: 16px;
            height: 16px;
            background: rgba(0, 0, 0, 0.85);
          }
          .mark {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(0, 0, 0, 0.5);
            .handle-wrap {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              .el-button {
                width: 110px;
                margin: 0;
                margin-bottom: 8px;
              }
            }
          }
          & > .selected {
            border-radius: 2px;
            position: absolute;
            right: 6px;
            top: 6px;
            width: 16px;
            height: 16px;
            background: yellow;
            text-align: center;

            &::after {
              content: "✔";
              color: #e60027;
              font-size: 12px;
            }
          }

          & > .mselected {
            border-radius: 2px;
            position: absolute;
            right: 6px;
            top: 6px;
            width: 16px;
            height: 16px;
            background: #e60027;
            text-align: center;

            &::after {
              content: "✔";
              color: #fff;
              font-size: 12px;
            }
          }
        }

        .text {
          padding-top: 16px;
          font-size: 12px;
          padding-bottom: 16px;
        }
      }

      &::after {
        content: "";
        flex: 0 0 180px;
      }
    }

    .loading {
      text-align: center;
      padding: 20px 0;
    }
  }

  .scrollbar-con {
    margin-top: 20px;
    height: 400px;
    overflow-x: hidden !important;

    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden !important;
    }
  }

  .drawer-con {
    position: absolute;
    right: 0;
    top: 82px;
    bottom: 0;
    background-color: #fff;
    z-index: 888;
    box-shadow: 0 0 10px #ccc;

    & > .btn-con {
      position: absolute;
      left: -40px;
      top: 50%;
      width: 40px;
      height: 160px;
      margin-top: -80px;
      text-align: center;
      cursor: pointer;

      & > .close {
        height: 160px;
        width: 40px;
        background: url("~@/assets/imgs/btn_arrow_right@2x.png") no-repeat center center / 40px auto;
      }

      & > .open {
        height: 160px;
        width: 40px;
        background: url("~@/assets/imgs/btn_arrow_left@2x.png") no-repeat center center / 40px auto;
      }
    }

    & > .list-con {
      width: 270px;
      height: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      & > .title {
        flex: 0 0 auto;
        padding: 24px;
        font-size: 16px;
        font-weight: bold;
        & > .clear {
          float: right;
          padding-right: 10px;
          font-weight: normal;
          color: #e60027;
          cursor: pointer;
        }
      }

      & > .img-con {
        flex: 1;

        padding: 0 14px;
        overflow-y: auto;

        & > .drag-group {
          border: 2px solid #eee;
          padding: 10px;
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>
